import {encryptByMD5, encryptByAES, decryptByAES, encryptByRSA} from './EncryptionAndDecryption'
import store from '../store'

// 报文体加密
function getEncryptBody (appCode, bizCode, msgBody, handleType, isDesensit) {
  msgBody.operaType = handleType
  let result = getHeader()
  let headers = result.headers
  let macKey = result.macKey
  let token = result.token
  let timeStamp = result.timeStamp

  // 组织报文体
  let data = {
    AppCode: appCode,
    BizCode: bizCode,
    BizBodyMsg: msgBody,
    isDesensit: isDesensit,
    token: token,
    timeStamp: timeStamp
  }

  // MD5签名
  let dataByMD5 = {
    msg: JSON.stringify(data),
    sign: encryptByMD5(JSON.stringify(data))
  }
  console.log('~~~~~' + appCode + bizCode + '请求报文:')
  console.log(data)
  // console.log('~~~~~' + appCode + bizCode + '加密mackey:' + macKey)

  // 用mackey对报文加密
  let encryptMsg = encryptByAES(JSON.stringify(dataByMD5), macKey)

  return {
    body: encryptMsg,
    headers: headers,
    interfaceCode: macKey
  }
}

// 报文体解密
function getDecryptBody (data, interfaceCode, appCode, bizCode) {
  let macKey = store.state.macKeyObj[interfaceCode]
  let decryptMsg = JSON.parse(decryptByAES(data, macKey))
  console.log('+++++++++++++++' + appCode + bizCode + '响应报文:' + '+++++++++++++++')
  console.log(decryptMsg)
  return decryptMsg
}

// 报文头处理
function getHeader () {
  // 生成mackey和pinkey（保存mackey）
  let macKey = getNonceStr()
  let interfaceCode = macKey
  let pinKey = store.state.pinKey
  let macKeyObj = JSON.parse(JSON.stringify(store.state.macKeyObj))
  macKeyObj[interfaceCode] = macKey
  store.commit('setMacKeyObj', macKeyObj)
  let encryptPinKey = encryptByRSA(pinKey, store.state.publicKey)
  let encryptMacKey = encryptByRSA(macKey, store.state.publicKey)
  // 生成token和timestamp
  let token = getNonceStr()
  let timeStamp = Date.now()
  return {
    macKey: macKey,
    headers: {'bodyKey': encryptMacKey, 'pinKey': encryptPinKey},
    interfaceCode: interfaceCode,
    token: token,
    timeStamp: timeStamp
  }
}

function validateOfSign (msgBody, signBody) {
  // MD5签名
  let sign = encryptByMD5(JSON.stringify(msgBody))
  return sign === signBody
}

// 生成pinKey
function getPinKey () {
  let pinKey = getNonceStr()
  store.commit('setPinKey', pinKey)
  return pinKey
}

// 生成密钥
function getNonceStr (len = 16) {
  const str = Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2)
  const start = Math.ceil(Math.random() * 10)
  return str.slice(start, start + len).padStart(len, '0')
}

export {getEncryptBody, getDecryptBody, getHeader, getNonceStr, getPinKey, validateOfSign}



// WEBPACK FOOTER //
// ./src/util/makePostData.js